import { createAsyncThunk } from "@reduxjs/toolkit";
import { cancelPayment, createPayment, getPaymentStatus, getPriceApparat} from "../services/paymentsServices";
import { createFreePrint, isFreePrintEnabled } from "../../services/kioskServiceSession";
import i18n from "../../locales/i18n";

export const createPaymentAction = createAsyncThunk(
    "payments/createPayment",
    async (paymentData, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("access_token");
            const deviceToken = localStorage.getItem("deviceToken");
            if (window.electronAPI?.pbreader) {
                const response = await window.electronAPI.pbreader.preflight({ items: paymentData, accessToken: token });
                if (!response?.ok) throw new Error(i18n.t("editDoc.preflight_error"));
                paymentData = paymentData.map((item, index) => {
                    const checked = response.result[index];
                    if (checked?.document_id !== item.document_id || checked.count_pages !== item.count_pages) {
                        throw new Error(i18n.t("editDoc.pages_changed"));
                    }
                    return { ...item, ...checked };
                });
            }
            
            const data = isFreePrintEnabled()
                ? await createFreePrint(paymentData)
                : await createPayment(paymentData, token, deviceToken);
            
            return data;
        } catch (error) {
            if (error.response?.status === 401) {
                return rejectWithValue(
                    i18n.t("editDoc.sign_in_again")
                );
            }
            return rejectWithValue(
                error.response?.data?.detail || error.message || i18n.t("editDoc.payment_error")
            );
        }
    }
);


// Опрос PaymentPage.jsx, пока платёж не завершён — не через createAsyncThunk
// pending/rejected в общем виде (те гасят страницу лоадером/тостом ошибки,
// см. loadingPayment в reducer'е), а тихо: сетевой сбой одного опроса — не
// повод перекрашивать весь экран, следующий тик (3с) всё равно попробует снова.
export const fetchPaymentStatus = createAsyncThunk(
    "payments/fetchPaymentStatus",
    async ({ orderId, provider }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("access_token");
            const deviceToken = localStorage.getItem("deviceToken");
            return await getPaymentStatus(orderId, provider, token, deviceToken);
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Ошибка получения статуса платежа"
            );
        }
    }
);

// rejectWithValue отдаёт HTTP-статус, а не текст: сервер отвечает по-русски,
// а экран переводит отказ сам (409 — оплата уже началась, прочее — сбой).
export const cancelPaymentAction = createAsyncThunk(
    "payments/cancelPayment",
    async ({ orderId, provider }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("access_token");
            const deviceToken = localStorage.getItem("deviceToken");
            return await cancelPayment(orderId, provider, token, deviceToken);
        } catch (error) {
            return rejectWithValue({ status: error.response?.status ?? null });
        }
    }
);

export const fetchPriceApparat = createAsyncThunk(
    "payments/fetchPriceApparat",
    async (_, { rejectWithValue }) => {
        try {
            const deviceToken = localStorage.getItem("deviceToken");
            const data = await getPriceApparat(deviceToken);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || "Ошибка загрузки цены аппарата"
            );
        }
    }
);

// Background refresh must not interrupt preview with a payment loading screen.
export const refreshPriceApparat = createAsyncThunk("payments/refreshPriceApparat", async () =>
    getPriceApparat(localStorage.getItem("deviceToken"))
);
